var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-fit"},[(typeof this.svg == 'object')?_c('div',_vm._b({ref:"template",staticClass:"template",staticStyle:{"height":"100%"},attrs:{"id":"template"}},'div',_vm.fields,false)):_c(_vm.component,_vm._b({ref:"svg_element",tag:"component"},'component',_vm.fields,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }